import { render, staticRenderFns } from "./AddFirstProject-View.vue?vue&type=template&id=37b5af81&scoped=true&"
import script from "./AddFirstProject-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddFirstProject-View.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddFirstProject-View.vue?vue&type=style&index=0&id=37b5af81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b5af81",
  null
  
)

export default component.exports